import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import Dt_Cal from "../../lib/ui/dt_cal";

import Sid_Add from "./fkn/sid_add";
import Sid_Open from "./fkn/sid_open";
import ddo from "../../ddo";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Msa_Sids extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;

    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = ddo.cache.avd;
    this.state.saa = [];
    this.state.aa = [];
    this.state.mno = {};
    this.state.wnds = {};
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.sids();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

    sid_add() {
    var self = this;

    var wnds = {};
    wnds.sidadd = true;
    wnds.uid = {};
    wnds.backdrop = true;
    self.setState({wnds: wnds });
  }
  sid_edit(row) {
    var self = this;
    var wnds = {};
    wnds.sidopen = true;
    wnds.sdo = row;
    wnds.backdrop = true;
    self.setState({wnds: wnds });
  }

  upd(ctx) {
    ctx.setState({wnds: {} });
    ctx.steps();
  }

    sids() {
    var self = this;
    var prm = {};
    prm.req = "wsc.msa.sids";
    prm.avd = this.state.avd;
    //prm.fplu = datum;
    //prm.tplu = datum;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({saa: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row">
        <select className="form-control w250 hide" placeholder="Välj avdelning">
            { this.props.store.pos.deps.map((row, key) =>
            <option key={key} value={row.avd}>{row.avd} - {row.text}</option>
            )}
        </select>
        <div className="flex"></div>
        <button className="btn btn-hw-blue w150" onClick={() => this.sid_add() } aria-label="System" >
            NY
        </button>
        <button className="btn btn-hw-blue w150" onClick={() => this.sids() } aria-label="System" >
            Visa
        </button>
    </div>
    <div className="divider_orange"></div>

    <div className="web-row">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
                <th>System</th>
                <th>SID</th>
                <th>Text</th>
                <th>Typ</th>
                <th>Status</th>
                <th>Status</th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.saa.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.sid_edit(row) }>
                <td>{ row.uid }</td>
                <td>{ row.sid }</td>
                <td>{ row.text }</td>
                <td>{ row.styp }</td>
                <td>{ row.status }</td>
                <td>{ row.status }</td>
            </tr>
            )}
            </tbody>
        </table>
    </div>

        { this.state.wnds.sidadd ? <Sid_Add wnds={this.state.wnds} ctx={this} store={this.store} /> : null}
        { this.state.wnds.sidopen ? <Sid_Open wnds={this.state.wnds} ctx={this} store={this.store} /> : null}
    </div>
  );
    }
}
export default Msa_Sids;
